var _a, _b;
import { __assign, __spreadArray } from "tslib";
import { actionKey } from './constants';
import { uploadFile, uploadFiles, uploadProgress, uploadSuccess, uploadFailure, uploadFileImmediately, removeErroredUpload, } from './actions';
import { handleActions } from 'redux-actions';
var defaultState = {
    fileUploads: [],
    fileUploadsWaiting: [],
};
var actionHandlers = handleActions((_a = {},
    _a[uploadFile.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { fileUploadsWaiting: __spreadArray(__spreadArray([], state.fileUploadsWaiting, true), [__assign({}, payload)], false) }));
    },
    _a[uploadFiles.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { fileUploadsWaiting: __spreadArray(__spreadArray([], state.fileUploadsWaiting, true), payload.files, true) }));
    },
    _a[uploadFileImmediately.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { fileUploads: __spreadArray(__spreadArray([], state.fileUploads, true), [__assign({}, payload)], false), fileUploadsWaiting: state.fileUploadsWaiting.filter(function (f) { return f.fileId !== payload.fileId; }) }));
    },
    _a[uploadFailure.toString()] = function (state, _a) {
        var _b = _a.payload, fileId = _b.fileId, error = _b.error;
        return (__assign(__assign({}, state), { fileUploads: __spreadArray([], state.fileUploads, true).map(function (item) {
                return item.fileId === fileId ? __assign(__assign({}, item), { error: error }) : item;
            }) }));
    },
    _a[uploadProgress.toString()] = function (state, _a) {
        var _b = _a.payload, fileId = _b.fileId, progress = _b.progress;
        return (__assign(__assign({}, state), { fileUploads: __spreadArray([], state.fileUploads, true).map(function (item) {
                return item.fileId === fileId ? __assign(__assign({}, item), { progress: progress }) : item;
            }) }));
    },
    _a[uploadSuccess.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (__assign(__assign({}, state), { fileUploads: state.fileUploads.filter(function (item) { return payload.fileId !== item.fileId; }) }));
    },
    _a[removeErroredUpload.toString()] = function (state, _a) {
        var fileId = _a.payload.fileId;
        return (__assign(__assign({}, state), { fileUploads: state.fileUploads.filter(function (item) { return !(item.fileId === fileId && item.error); }) }));
    },
    _a), defaultState);
var reducers = (_b = {},
    _b[actionKey] = actionHandlers,
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map